import React from "react";
import { useTranslation } from "react-i18next";

const Trustbar = () => {
    const { t } = useTranslation();

    return (
        <section className="border-y border-gray-200 bg-gray-50 py-8">
            <div className="container mx-auto px-4">
                <div className="grid grid-cols-2 gap-4 text-center lg:grid-cols-4">
                    <div>
                        <div className="text-[32px] font-extrabold tracking-[-1px] text-primaryBlue">
                            {t("1,000+")}
                        </div>
                        <div className="mt-1 text-[14px] font-medium text-gray-500">
                            {t("Active stores")}
                        </div>
                    </div>
                    <div>
                        <div className="text-[32px] font-extrabold tracking-[-1px] text-primaryBlue">
                            {t("2.4M+")}
                        </div>
                        <div className="mt-1 text-[14px] font-medium text-gray-500">
                            {t("Transactions / month")}
                        </div>
                    </div>
                    <div>
                        <div className="text-[32px] font-extrabold tracking-[-1px] text-primaryBlue">
                            {t("27")}
                        </div>
                        <div className="mt-1 text-[14px] font-medium text-gray-500">
                            {t("Egyptian governorates")}
                        </div>
                    </div>
                    <div>
                        <div className="text-[32px] font-extrabold tracking-[-1px] text-primaryBlue">
                            {t("99.9%")}
                        </div>
                        <div className="mt-1 text-[14px] font-medium text-gray-500">
                            {t("Uptime SLA")}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Trustbar;